import { Skeleton } from '@packages/shared';

/**
 * Displays a skeleton for the 'share' button
 * */
export const ShareButtonSkeleton = () => <Skeleton variant="rounded" height={38} />;
